import gql from 'graphql-tag';
import { ApolloClient } from 'apollo-client';
import { useCallback } from 'react';
import { throwQueryError } from '../lib/apollo/throwQueryError';
import {
  ErrorModalQuery,
  ErrorModalQuery_errorModal as ErrorModal
} from '../generated/types/ErrorModalQuery';
import { useLocalQuery } from './useLocalQuery';

export const typeDefs = gql`
  type ErrorModal {
    show: Boolean!
  }
`;

export const ERROR_MODAL_QUERY = gql`
  query ErrorModalQuery {
    errorModal @client {
      show
    }
  }
`;

export const ERROR_MODAL_DEFAULTS: ErrorModal = {
  __typename: 'ErrorModal',
  show: false
};

const toggleErrorModal = <T>(client: ApolloClient<T>, show: boolean) =>
  client.writeQuery<ErrorModalQuery>({
    query: ERROR_MODAL_QUERY,
    data: { errorModal: { __typename: 'ErrorModal', show } }
  });

export const useErrorModal = () => {
  const { data, error, client } = useLocalQuery<ErrorModalQuery>(ERROR_MODAL_QUERY);
  const showErrorModal = useCallback(() => toggleErrorModal(client, true), [client]);
  const hideErrorModal = useCallback(() => toggleErrorModal(client, false), [client]);

  if (error) throwQueryError(error);

  return {
    show: data?.errorModal?.show || false,
    showErrorModal,
    hideErrorModal
  };
};
